import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "methodField"]

  toggle() {
    const track = this.trackTarget
    const isActive = track.classList.toggle("bg-core-purple-500")
    track.classList.toggle("bg-support-light-300", !isActive)
    track.setAttribute("aria-checked", isActive)

    const thumb = track.querySelector("span")
    if (isActive) {
      thumb.classList.replace("translate-x-0", "translate-x-4")
      this.methodFieldTarget.value = "secure_message"
    } else {
      thumb.classList.replace("translate-x-4", "translate-x-0")
      this.methodFieldTarget.value = "email"
    }
  }

  keyToggle(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.toggle()
    }
  }

  resetToggle() {
    if (!this.hasTrackTarget) return
    const track = this.trackTarget
    track.classList.remove("bg-core-purple-500")
    track.classList.add("bg-support-light-300")
    track.setAttribute("aria-checked", "false")
    const thumb = track.querySelector("span")
    if (thumb) thumb.classList.replace("translate-x-4", "translate-x-0")
  }

  enableSecure(event) {
    event.preventDefault()
    this.methodFieldTarget.value = "secure_message"
    if (this.hasTrackTarget) {
      const track = this.trackTarget
      track.classList.add("bg-core-purple-500")
      track.classList.remove("bg-support-light-300")
      track.setAttribute("aria-checked", "true")
      const thumb = track.querySelector("span")
      if (thumb) thumb.classList.replace("translate-x-0", "translate-x-4")
    }
  }
}
